import React from "react";
import { Box, Typography, TextField, FormControlLabel, Checkbox, Radio, RadioGroup, FormControl, FormLabel, MenuItem, Select, InputLabel, FormHelperText } from "@mui/material";

export default function EventSignupQuestions({ values, onChange, onBlur, readOnly, errors = {}, touched = {} }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl required error={!!(touched.within2Hours && errors.within2Hours)}>
        <FormLabel>1) Do you live within 2 hours of Akron, Ohio?</FormLabel>
        <RadioGroup row name="within2Hours" value={values.within2Hours || ''} onChange={readOnly ? undefined : onChange} onBlur={readOnly ? undefined : onBlur}>
          <FormControlLabel value="yes" control={<Radio />} label="Yes" disabled={readOnly} />
          <FormControlLabel value="no" control={<Radio />} label="No" disabled={readOnly} />
        </RadioGroup>
        {touched.within2Hours && errors.within2Hours && <FormHelperText>{errors.within2Hours}</FormHelperText>}
      </FormControl>
      <TextField
        required
        label="2) Why do you want to attend our event?"
        name="whyAttend"
        value={values.whyAttend || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        multiline
        minRows={2}
        error={!!(touched.whyAttend && errors.whyAttend)}
        helperText={touched.whyAttend && errors.whyAttend ? errors.whyAttend : undefined}
        InputProps={{ readOnly }}
      />
      <TextField
        required
        label="3) Please explain your relationship with Jesus."
        name="jesusRelationship"
        value={values.jesusRelationship || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        multiline
        minRows={2}
        error={!!(touched.jesusRelationship && errors.jesusRelationship)}
        helperText={touched.jesusRelationship && errors.jesusRelationship ? errors.jesusRelationship : undefined}
        InputProps={{ readOnly }}
      />
      <TextField
        required
        label="4) What is your nickname / first name preference?"
        name="nickname"
        value={values.nickname || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        error={!!(touched.nickname && errors.nickname)}
        helperText={touched.nickname && errors.nickname ? errors.nickname : undefined}
        InputProps={{ readOnly }}
      />
      <FormControl required error={!!(touched.legallySingle && errors.legallySingle)}>
        <FormLabel>5) Are you legally single?</FormLabel>
        <RadioGroup row name="legallySingle" value={values.legallySingle || ''} onChange={readOnly ? undefined : onChange} onBlur={readOnly ? undefined : onBlur}>
          <FormControlLabel value="yes" control={<Radio />} label="Yes" disabled={readOnly} />
          <FormControlLabel value="no" control={<Radio />} label="No" disabled={readOnly} />
        </RadioGroup>
        {touched.legallySingle && errors.legallySingle && <FormHelperText>{errors.legallySingle}</FormHelperText>}
      </FormControl>
      <TextField
        required
        label="6) Church you attend."
        name="church"
        value={values.church || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        error={!!(touched.church && errors.church)}
        helperText={touched.church && errors.church ? errors.church : undefined}
        InputProps={{ readOnly }}
      />
      <TextField
        required
        label="7) Please provide 3 words to describe your personality. These will be listed next to your name at our event."
        name="personalityWords"
        value={values.personalityWords || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        error={!!(touched.personalityWords && errors.personalityWords)}
        helperText={touched.personalityWords && errors.personalityWords ? errors.personalityWords : "Separate words with commas."}
        InputProps={{ readOnly }}
      />
      <FormControl required error={!!(touched.hasCharges && errors.hasCharges)}>
        <FormLabel>8) Do you have any misdemeanor or felony charges?</FormLabel>
        <RadioGroup row name="hasCharges" value={values.hasCharges || ''} onChange={readOnly ? undefined : onChange} onBlur={readOnly ? undefined : onBlur}>
          <FormControlLabel value="no" control={<Radio />} label="No" disabled={readOnly} />
          <FormControlLabel value="yes" control={<Radio />} label="Yes" disabled={readOnly} />
        </RadioGroup>
        {touched.hasCharges && errors.hasCharges && <FormHelperText>{errors.hasCharges}</FormHelperText>}
      </FormControl>
      <TextField
        required
        label="9) Is there anything else we need to know about your background?"
        name="backgroundInfo"
        value={values.backgroundInfo || ''}
        onChange={readOnly ? undefined : onChange}
        onBlur={readOnly ? undefined : onBlur}
        multiline
        minRows={2}
        error={!!(touched.backgroundInfo && errors.backgroundInfo)}
        helperText={touched.backgroundInfo && errors.backgroundInfo ? errors.backgroundInfo : undefined}
        InputProps={{ readOnly }}
      />
      <FormControl required error={!!(touched.paymentMethod && errors.paymentMethod)}>
        <FormLabel>10) How will you be paying?</FormLabel>
        <RadioGroup name="paymentMethod" value={values.paymentMethod || ''} onChange={readOnly ? undefined : onChange} onBlur={readOnly ? undefined : onBlur}>
          <FormControlLabel value="venmo" control={<Radio />} label="Venmo: KelseyStokes" disabled={readOnly} />
          <FormControlLabel value="paypal" control={<Radio />} label="PayPal: kelseystokes985@gmail.com" disabled={readOnly} />
          <FormControlLabel value="cashapp" control={<Radio />} label="Cash app: KelseyStokes5" disabled={readOnly} />
          <FormControlLabel value="zelle" control={<Radio />} label="Zelle: 330-212-5375" disabled={readOnly} />
        </RadioGroup>
        {touched.paymentMethod && errors.paymentMethod && <FormHelperText>{errors.paymentMethod}</FormHelperText>}
      </FormControl>
      <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="body2">
          <b>User Agreement:</b> By completing this form, you certify all of the information provided is true, genuine, and complete to the best of your knowledge, and that it accurately represents your identity and background. Tickets are nonrefundable. No exceptions.
        </Typography>
        <FormControlLabel
          control={<Checkbox name="agreementAccepted" checked={!!values.agreementAccepted} onChange={readOnly ? undefined : onChange} onBlur={readOnly ? undefined : onBlur} required disabled={readOnly} />}
          label="I accept the user agreement."
        />
        {touched.agreementAccepted && errors.agreementAccepted && (
          <Typography variant="caption" color="error">{errors.agreementAccepted}</Typography>
        )}
      </Box>
    </Box>
  );
}
